import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import ComputPage from '@/components/ComputePage.vue';
import ComputeWizardSize from '@/components/ComputeWizard/ComputeWizardSize.vue';
import { RoutePath } from '@/enums/Router';

export default /*#__PURE__*/_defineComponent({
  __name: 'ComputeSizePage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ComputPage, {
    title: _ctx.$t('home.steps.size.label'),
    class: "compute-size-page",
    "current-step": 1,
    "next-url": _unref(RoutePath).COMPUTE_STEP_SURFACE
  }, {
    default: _withCtx(() => [
      _createVNode(ComputeWizardSize)
    ]),
    _: 1
  }, 8, ["title", "next-url"]))
}
}

})